import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); // to track which dropdown is open

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenDropdown(null); // close dropdowns also
  };

  const toggleDropdown = (dropdownName, e) => {
    e.preventDefault();
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  return (
    <div className="page-wrapper" id="page">
      <header className={`site-header header-style-1 ${isMenuOpen ? "active" : ""}`}>
        <div className="pbmit-header-overlay">
          <div className="pbmit-main-header-area">
            <div className="container-fluid">
              <div className="pbmit-header-content d-flex justify-content-between align-items-center">
                <div className="pbmit-logo-menuarea d-flex justify-content-between align-items-center">
                  <div className="site-branding">
                    <h1 className="site-title">
                      <Link to="/">
                        <img
                          className="logo-img logo-pos"
                          src={`${process.env.PUBLIC_URL}/assets/images/logo2.png`}
                          alt="XR TRACKLINE"
                        />
                      </Link>
                    </h1>
                  </div>
                  <div className="site-navigation">
                    <nav className="main-menu navbar-expand-xl navbar-light">
                      <div className="navbar-header">
                        {/* Toggle Button */}
                        <button
                          className="navbar-toggler"
                          type="button"
                          onClick={toggleMenu}
                          aria-expanded={isMenuOpen}
                          aria-label="Toggle navigation"
                        >
                          <i className="pbmit-base-icon-menu-1" />
                        </button>
                      </div>
                      <div className="pbmit-mobile-menu-bg" />
                      <div
                        className={`collapse navbar-collapse clearfix ${isMenuOpen ? "show" : ""}`}
                        id="pbmit-menu"
                      >
                        <div className="pbmit-menu-wrap">
                          <span className="closepanel" onClick={closeMenu}>
                            <svg
                              className="qodef-svg--close qodef-m"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20.163"
                              height="20.163"
                              viewBox="0 0 26.163 26.163"
                            >
                              <rect
                                width={36}
                                height={1}
                                transform="translate(0.707) rotate(45)"
                              />
                              <rect
                                width={36}
                                height={1}
                                transform="translate(0 25.456) rotate(-45)"
                              />
                            </svg>
                          </span>
                          <ul className="navigation clearfix">
                            <li>
                              <Link to="/" onClick={closeMenu}>
                                Home
                              </Link>
                            </li>
                            <li>
                              <Link to="/about" onClick={closeMenu}>
                                About Us
                              </Link>
                            </li>
                            <li>
                              <Link to="/services" onClick={closeMenu}>
                                Services
                              </Link>
                            </li>

                            {/* Ship with us Dropdown */}
                            <li className={`dropdown ${openDropdown === "ship" ? "open" : ""}`}>
                              <a
                                href="#"
                                onClick={(e) => toggleDropdown("ship", e)}
                              >
                                Ship with us
                              </a>
                              <ul className={openDropdown === "ship" ? "open" : ""}>
                                <li><Link to="/drayage" onClick={closeMenu}>Drayage</Link></li>
                                <li><Link to="/warehousing" onClick={closeMenu}>Warehousing</Link></li>
                                <li><Link to="/over-the-road" onClick={closeMenu}>Over The Road</Link></li>
                                <li><Link to="/intermodal" onClick={closeMenu}>Intermodal</Link></li>
                                <li><Link to="/flatbed" onClick={closeMenu}>Flatbed</Link></li>
                                <li><Link to="/reefer" onClick={closeMenu}>Reefer</Link></li>
                                <li><Link to="/ltl" onClick={closeMenu}>LTL</Link></li>
                                <li><Link to="/cross-border" onClick={closeMenu}>Cross Border Logistics</Link></li>
                              </ul>
                            </li>

                            {/* Industries Dropdown */}
                            <li className={`dropdown ${openDropdown === "industries" ? "open" : ""}`}>
                              <a
                                href="#"
                                onClick={(e) => toggleDropdown("industries", e)}
                              >
                                Industries
                              </a>
                              <ul className={openDropdown === "industries" ? "open" : ""}>
                                <li><Link to="/automotive" onClick={closeMenu}>Automotive</Link></li>
                                <li><Link to="/food-beverage" onClick={closeMenu}>Food & Beverage</Link></li>
                                <li><Link to="/produce" onClick={closeMenu}>Produce</Link></li>
                                <li><Link to="/renewable-energy" onClick={closeMenu}>Renewable Energy</Link></li>
                                <li><Link to="/retail" onClick={closeMenu}>Retail</Link></li>
                                <li><Link to="/manufacturing" onClick={closeMenu}>Manufacturing</Link></li>
                                <li><Link to="/building-materials" onClick={closeMenu}>Building Materials</Link></li>
                                <li><Link to="/oil-gas-energy" onClick={closeMenu}>Oil & Gas Energy</Link></li>
                                <li><Link to="/healthcare-pharma" onClick={closeMenu}>Healthcare & Pharma</Link></li>
                                <li><Link to="/government-defense" onClick={closeMenu}>Government & Defense</Link></li>
                              </ul>
                            </li>

                            <li>
                              <Link to="/contact" onClick={closeMenu}>
                                Contact Us
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
                <div className="pbmit-right-box d-flex align-items-center">
                  <div className="social-links-wrapper">
                    <ul className="pbmit-social-links">
                      <li className="pbmit-social-li pbmit-social-facebook">
                        <a title="Facebook" href="https://www.facebook.com" target="_blank" rel="noreferrer">
                          <span><i className="pbmit-base-icon-facebook-f" /></span>
                        </a>
                      </li>
                      <li className="pbmit-social-li pbmit-social-twitter">
                        <a title="Twitter" href="https://www.twitter.com" target="_blank" rel="noreferrer">
                          <span><i className="pbmit-base-icon-twitter-2" /></span>
                        </a>
                      </li>
                      <li className="pbmit-social-li pbmit-social-linkedin">
                        <a title="LinkedIn" href="https://www.linkedin.com" target="_blank" rel="noreferrer">
                          <span><i className="pbmit-base-icon-linkedin-in" /></span>
                        </a>
                      </li>
                      <li className="pbmit-social-li pbmit-social-instagram">
                        <a title="Instagram" href="https://www.instagram.com" target="_blank" rel="noreferrer">
                          <span><i className="pbmit-base-icon-instagram" /></span>
                        </a>
                      </li>
                    </ul>
                  </div>

                 <div className="pbmit-header-button2">
  <Link className="pbmit-btn pbmit-btn-white" to="/coming-soon">
    <span className="pbmit-button-content-wrapper">
      <span className="pbmit-button-text">Book Consult</span>
    </span>
  </Link>
</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
